'use strict';

function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService)
{
    let async = require('async');
    let model = this;

    $scope.global = Global;
    model.settings = settings;
    model.color = d3.scale.category10();

    model.lineChartIdentifiers = { key: false, id: false };
    model.pieChartIdentifiers = { key: false, id: false };
    model.tableIdentifiers = { key: false, id: false };

    let obj = {};

    socketIo('/api/hunting/ssl_certs').then(function(socket)
    {
        // async.series(
        // { // Pie chart has to run before the line chart so it can group the 'top 10' categories
        //     one: function(callback)
        //     {
        //         /* -----------*/
        //         /*  PIECHART  */
        //         /* -----------*/
        //
        //         // register data object
        //         $scope.main.registerVisual(
        //         {
        //             // key: 'crossfilter', // bound to the response, wrap entire source if undefined
        //             refresh: true, // if a number is placed here, it will overwrite the current 1min default
        //             searchable: true, // optional search param.. no if undefined
        //             get: {
        //                 call: 'piechart',
        //                 socket: socket
        //             }, // no get default to main url, strings will replace the default (otherwise /[from root])
        //             grouping: ['sub'],
        //             filter_column: 'sub',
        //             searchCategories:
        //             {
        //                 'sub': 'Subject',
        //             },
        //             type: 'piechart',
        //             settings:
        //             {
        //                 type: 'application',
        //                 xAxis: '',
        //                 yAxis: ''
        //             },
        //             dimension: function(cfObj)
        //             {
        //                 return cfObj.dimension(function(d)
        //                 {
        //                     return d.top_server;
        //                 });
        //             },
        //             group: function(dimension) // groups are optional and should default to a reduce if undefined
        //             {
        //                 return dimension.group().reduceSum(function(d)
        //                 {
        //                     return d.count;
        //                 });
        //             },
        //         })
        //         // fetch the data when the object is registered
        //         .then(function(result)
        //         {
        //             model.pieChartIdentifiers = { id: result.id, key: result.key };
        //             // initalize table with column information so it can compile the directive
        //             return new fetchStream(result.settings.get.call, result.settings.get.socket);
        //         })
        //         .then(function(result)
        //         {
        //             // stop spinner on complete or no data
        //             if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched)
        //                 usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
        //
        //             obj = {};
        //
        //             if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched)
        //             {
        //                 let top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
        //
        //                 for (var i = 0, len = top.length; i < len; i++)
        //                     obj[top[i].key] = 0;
        //
        //                 if (top.length >= 9)
        //                     obj['Other'] = 0;
        //
        //                 model.setGroupObj(obj);
        //             };
        //
        //             callback(null, 'one');
        //         },
        //         function(err)
        //         {
        //
        //         },
        //         function(result)
        //         {
        //             $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
        //
        //             if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched)
        //             {
        //                 $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
        //                 $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
        //
        //                 $scope.$broadcast('init', model.pieChartIdentifiers);
        //                 // stop spinner on inital data
        //                 usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
        //             }
        //
        //             else
        //                 $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
        //         })
        //     },
        //     two: function(callback)
        //     {
        //         /* ------------*/
        //         /*  LINECHART  */
        //         /* ------------*/
        //
        //         // register data object
        //         $scope.main.registerVisual(
        //         {
        //             refresh: true, // if a number is placed here, it will overwrite the current 1min default
        //             searchable: true, // optional search param.. no if undefined
        //             get:
        //             {
        //                 call: 'linechart',
        //                 socket: socket
        //             }, // no get default to main url, strings will replace the default (otherwise /[from root])
        //             grouping: ['hour', 'sub'],
        //             hideToggleBytes: true,
        //             type: 'linechart',
        //             settings:
        //             {
        //                 use_color: true,
        //                 type: 'bar',
        //                 xAxis: '',
        //                 yAxis: 'Subject Appearance / Hour'
        //             },
        //             searchCategories:
        //             {
        //                 'time': 'Time',
        //                 'sub': 'Subject',
        //             },
        //             dimension: function(cfObj)
        //             {
        //                 return cfObj.dimension(function(d)
        //                 {
        //                     d.hour = Number(d.hour * 1000);
        //
        //                     return d.hour;
        //                 });
        //             },
        //             group: function(dimension) // groups are optional and should default to a reduce if undefined
        //             {
        //                 return dimension.group().reduce(
        //                     function(p, v)
        //                     {
        //                         if (obj.hasOwnProperty(v.top_server))
        //                             p[v.top_server] += v.count;
        //
        //                         else
        //                             p['Other'] += v.count;
        //
        //                         return p;
        //                     },
        //                     function(p, v)
        //                     {
        //                         if (obj.hasOwnProperty(v.top_server))
        //                             p[v.top_server] -= v.count;
        //
        //                         else
        //                             p['Other'] -= v.count;
        //
        //                         return p;
        //                     },
        //                     function()
        //                     {
        //                         return angular.copy(obj);
        //                     }
        //                 );
        //             },
        //         })
        //         // fetch the data when the object is registered
        //         .then(function(result)
        //         {
        //             model.lineChartIdentifiers = { id: result.id, key: result.key };
        //             // set dimension & group
        //             $scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
        //             $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
        //             // return new fetchStream(result.settings.get.call, result.settings.get.socket);
        //             return new fetchStream(result.settings.get.call, result.settings.get.socket);
        //         })
        //         .then(function(result)
        //         {
        //             // stop spinner on complete
        //             if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched)
        //                 usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
        //         },
        //         function(err)
        //         {
        //
        //         },
        //         function(result)
        //         {
        //             $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
        //
        //             if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched)
        //             {
        //                 $scope.$broadcast('init', model.lineChartIdentifiers);
        //                 // stop spinner on inital data
        //                 usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
        //             }
        //
        //             else
        //                 $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
        //         });
        //
        //         callback(null, 'two');
        //     }
        // },
        // function(err, results)
        // {
        //     // results is now equal to: {one: 1, two: 2}
        // });

        /* --------*/
        /*  TABLE  */
        /* --------*/

        // Register data object.
        $scope.main.registerVisual(
        {
            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
            searchable: true, // Optional search param... no if undefined.
            get:
            {
                call: 'table',
                socket: socket
            },
            hideToggleBytes: true,
            grouping: ['id'],
            sort:
            {
                direction: '-',
                col: 'vector'
            },
            title: '    Events',
            columns:
            [
                {
                    title: 'Time',
                    select: 'time',
                    dView: true
                },
                {
                    title: 'Fail due',
                    select: 'msg',
                    dView: true
                },
                {
                    title: 'Vector',
                    select: 'vector',
                    dView: true,
                    editTable: true
                }
            ],
            searchCategories:
            {
                'msg': 'Fail due',
                'orig_ip': 'Origin IP',
                'vector': 'Vector'
            }
        })
        .then(function(result) // Fetch the data when the object is registered.
        {
            model.tableIdentifiers = { id: result.id, key: result.key };
            // Initialize table with column information so it can compile the directive.
            $scope.$broadcast('table-build', model.tableIdentifiers);

            let time = angular.copy($scope.main.getTime());

            model.loadStart = time.end;
            model.loadEnd = time.end;
            // Return promise to build dimensions and groups for table.
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function(result)
        {
            model.complete = true;
            // Stop the table spinner as soon as the resolve comes in.
            usSpinnerService.stop(model.tableIdentifiers.id);
        },
        function(err)
        {
            // Nothing to do here.
        },
        function(result)
        {
            // Add rows.
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);

            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched)
            {
                // With our first data return, we can build dimensions and groups for our data.
                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function()
                {
                    // Don't start the spinner if the table loads faster than building group dim.
                    // Start table spinner right before init, but after build.
                    if (!model.complete)
                        usSpinnerService.spin(model.tableIdentifiers.id);
                    // Initialize rows.
                    $scope.$broadcast('init', model.tableIdentifiers);

                    if (result.min)
                        model.loadStart = result.min;
                },
                function(err)
                {
                    console.log('error');
                    console.log(err);
                });
            }

            else
            {
                if (result.min)
                    model.loadStart = result.min;

                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
            }
        });

        $scope.$on('$destroy', function()
        {
            socket.disconnect();
        });
    });
}

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/hunting/suspicious_subdomains.js
 **/